import {
    SET_MEMBER_DATA,
    SET_MEMBERS_DATA,
    SET_MEMBER_COUNT,
    SET_MEMBERS_CHECKIN_DATA,
  } from '../types/types';
  
  export const setMemberData = (value) => {
    return {
      type: SET_MEMBER_DATA,
      payload: { data: value },
    };
  };

  export const setOverLapBookings = (value) => {
    return {
      type: "SET_OVERLAP_DATA",
      payload: { data: value },
    };
  };
  
  export const setMemberCount = (value) => {
    return {
      type: SET_MEMBER_COUNT,
      payload: { data: value },
    };
  };
  export const setActiveTab = (value) => {
    return {
      type: 'SET_ACTIVE_TAB',
      payload: { data: value },
    };
  };
  
    export const setNotes = (value) => {
    return {
      type: 'SET_NOTES',
      payload: { data: value },
    };
  };
  export const setPurchasedProducts = (value) => {
    return {
      type: 'SET_MEMEBR_PURCHASED_PRODUCTS',
      payload: { data: value },
    };
  };
  
  export const setMembersData = (value) => {
    return {
      type: SET_MEMBERS_DATA,
      payload: { data: value },
    };
  };
  export const setAllMembersData = (value) => {
    return {
      type: 'SET_ALL_MEMBERS_DATA',
      payload: { data: value },
    };
  };
  export const setGiveBackMoney = (value) => {
    return {
      type: 'GIVE_BACK_MONEY',
      payload: { data: value },
    };
  };
  export const setMembersCheckinData = (value) => {
    return {
      type:   SET_MEMBERS_CHECKIN_DATA,
      payload: { data: value },
    };
  };
  export const setMemberAssessments = (value) => {
    return {
      type: "SET_MEMBER_ASSESSMENTS",
      payload: { data: value },
    };
  };
  export const setMemberAssessmentsCount = (value) => {
    return {
      type: "SET_MEMBER_ASSESSMENTS_COUNT",
      payload: { data: value },
    };
  };
  export const setMemberAssessmentsQuery = ({ page, limit }) => {
    return {
      type: "SET_MEMBER_ASSESSMENTS_QUERY",
      payload: { data: { page, limit } },
    };
  };
  export const setMemberTreatments = (value) => {
    return {
      type: "SET_MEMBER_TREATMENTS",
      payload: { data: value },
    };
  };
  export const setMemberTreatmentsCount = (value) => {
    return {
      type: "SET_MEMBER_TREATMENTS_COUNT",
      payload: { data: value },
    };
  };
  export const setMemberTreatmentsQuery = ({ page, limit }) => {
    return {
      type: "SET_MEMBER_TREATMENTS_QUERY",
      payload: { data: { page, limit } },
    };
  };